// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dancer-name{
  font-size: 16px;
  color: #424242;
  font-weight: 400;
  overflow-wrap: anywhere;
  text-align: justify;
}
.dancer-bday{
  font-size: 12px;
  color: rgb(104, 173, 63);
  font-weight: 500;
}
.dancer-school{
  font-size: 12px;
  color: #424242;
    font-weight: 500;
    overflow-wrap: anywhere;
    padding: 0px 57px 0px 0px;
    text-align: justify;
}
.deleteIcon-dancer{
  font-size: 20px;
  color: rgb(121, 121, 121);
  margin-top: 7px;
  margin-right: 7px;
}
.editIcon-dancer{
  font-size: 18px;
  color: rgb(121, 121, 121);
  margin-top: 8px;
  margin-right: 7px;
}

.updateChangeDisabled {
  opacity: 0.3;
  background-color: #68ad3f !important;
  color: white !important;
  pointer-events: none;
}
.account-flow .MuiButtonBase-root-MuiTab-root.Mui-selected {
  color: #68AD3F !important;
}
.css-sex162-MuiButtonBase-root-MuiButton-root.Mui-disabled {
  background-color: #68ad3f !important;
  color: #ffff !important;
}
.stripePagemain {
  width: 40vw;
}
.eventNameDancer{
  margin: 6px 0.25rem 0px 0.25rem !important;
}

.updateChange:hover {
  background-color: rgb(251, 176, 64);
}
.updateChange {
  cursor: pointer;
}
.account-flow .MuiButtonBase-root {
  font-size: 16px !important;
}
.hrpasword{
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  color: #EAEAEA;
}
.add_dance_btn{
  font-size: 17px !important;
}
.account-tab {
  border-bottom: 2px solid rgba(140, 174, 120, 0.12);
}
.account-tab .MuiTab-root {
  min-width: auto !important;
  padding: 12px 0 !important;
  color: #424242;
}

.css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
.tabs .css-13xfq8m-MuiTabPanel-root {
  padding: 24px 0;
}
.disabled-email {
  color: #c9c9c9 !important;
  background-color: transparent !important;
}
.account-flow h3 {
  font-weight: 400;
  margin: 30px 0 0 15px;
}
.account-flow input {
  width: 258px !important;
}
.account-flow select {
  width: 258px !important;
}
.dancers-profile {
  width: 310px;
  box-shadow: 0px 15px 28px rgba(0, 0, 0, 0.05);
  padding: 10px;
  margin-bottom: 10px;
}
.accountInput::placeholder {
  color: #eaeaea;
  font-size: 14px;
  font-weight: 400;
}
@media (min-width: 481px) {
  .account-tab {
    padding: 0 10%;
  }
  .tabs {
    padding: 0 10%;
  }
  .account-flow h3 {
    font-size: 20px;
    margin: 30px 0 0 11%;
  }
}
@media (min-width: 768px) {
  .account-tab {
    padding: 0 20%;
  }
  .tabs {
    padding: 0 20%;
  }
  .account-flow h3 {
    margin: 30px 0 0 22%;
  }
}
@media (min-width: 1024px) {
  .account-tab {
    padding: 0 30%;
  }
  .tabs {
    padding: 0 30%;
  }
  .account-flow h3 {
    font-size: 24px;
    margin: 30px 0 0 10%;
  }
}
@media ((min-width: 0px) and (max-width:700px)) {
  .css-byiuq4-MuiButtonBase-root-MuiTab-root {
    min-width: auto !important;
  }

  .account-flow {
    padding: 0 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Parent/Account/Style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,cAAc;EACd,SAAS;EACT,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kDAAkD;AACpD;AACA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,+CAA+C;AACjD;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,oBAAoB;EACtB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,oBAAoB;EACtB;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".dancer-name{\n  font-size: 16px;\n  color: #424242;\n  font-weight: 400;\n  overflow-wrap: anywhere;\n  text-align: justify;\n}\n.dancer-bday{\n  font-size: 12px;\n  color: rgb(104, 173, 63);\n  font-weight: 500;\n}\n.dancer-school{\n  font-size: 12px;\n  color: #424242;\n    font-weight: 500;\n    overflow-wrap: anywhere;\n    padding: 0px 57px 0px 0px;\n    text-align: justify;\n}\n.deleteIcon-dancer{\n  font-size: 20px;\n  color: rgb(121, 121, 121);\n  margin-top: 7px;\n  margin-right: 7px;\n}\n.editIcon-dancer{\n  font-size: 18px;\n  color: rgb(121, 121, 121);\n  margin-top: 8px;\n  margin-right: 7px;\n}\n\n.updateChangeDisabled {\n  opacity: 0.3;\n  background-color: #68ad3f !important;\n  color: white !important;\n  pointer-events: none;\n}\n.account-flow .MuiButtonBase-root-MuiTab-root.Mui-selected {\n  color: #68AD3F !important;\n}\n.css-sex162-MuiButtonBase-root-MuiButton-root.Mui-disabled {\n  background-color: #68ad3f !important;\n  color: #ffff !important;\n}\n.stripePagemain {\n  width: 40vw;\n}\n.eventNameDancer{\n  margin: 6px 0.25rem 0px 0.25rem !important;\n}\n\n.updateChange:hover {\n  background-color: rgb(251, 176, 64);\n}\n.updateChange {\n  cursor: pointer;\n}\n.account-flow .MuiButtonBase-root {\n  font-size: 16px !important;\n}\n.hrpasword{\n  margin: 1rem 0;\n  color: inherit;\n  border: 0;\n  border-top: 1px solid;\n  color: #EAEAEA;\n}\n.add_dance_btn{\n  font-size: 17px !important;\n}\n.account-tab {\n  border-bottom: 2px solid rgba(140, 174, 120, 0.12);\n}\n.account-tab .MuiTab-root {\n  min-width: auto !important;\n  padding: 12px 0 !important;\n  color: #424242;\n}\n\n.css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n.tabs .css-13xfq8m-MuiTabPanel-root {\n  padding: 24px 0;\n}\n.disabled-email {\n  color: #c9c9c9 !important;\n  background-color: transparent !important;\n}\n.account-flow h3 {\n  font-weight: 400;\n  margin: 30px 0 0 15px;\n}\n.account-flow input {\n  width: 258px !important;\n}\n.account-flow select {\n  width: 258px !important;\n}\n.dancers-profile {\n  width: 310px;\n  box-shadow: 0px 15px 28px rgba(0, 0, 0, 0.05);\n  padding: 10px;\n  margin-bottom: 10px;\n}\n.accountInput::placeholder {\n  color: #eaeaea;\n  font-size: 14px;\n  font-weight: 400;\n}\n@media (min-width: 481px) {\n  .account-tab {\n    padding: 0 10%;\n  }\n  .tabs {\n    padding: 0 10%;\n  }\n  .account-flow h3 {\n    font-size: 20px;\n    margin: 30px 0 0 11%;\n  }\n}\n@media (min-width: 768px) {\n  .account-tab {\n    padding: 0 20%;\n  }\n  .tabs {\n    padding: 0 20%;\n  }\n  .account-flow h3 {\n    margin: 30px 0 0 22%;\n  }\n}\n@media (min-width: 1024px) {\n  .account-tab {\n    padding: 0 30%;\n  }\n  .tabs {\n    padding: 0 30%;\n  }\n  .account-flow h3 {\n    font-size: 24px;\n    margin: 30px 0 0 10%;\n  }\n}\n@media ((min-width: 0px) and (max-width:700px)) {\n  .css-byiuq4-MuiButtonBase-root-MuiTab-root {\n    min-width: auto !important;\n  }\n\n  .account-flow {\n    padding: 0 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
